module.exports = __webpack_public_path__ + "static/media/experience.afe2978e.webp";